import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import { Link } from "react-router-dom";
import { FaPencilAlt, FaTrashAlt, FaArrowsAlt } from "react-icons/fa";
import {ability} from "../../../../config/acl/ability";

const DataTable = ({
                     data,
                     setSelectedId,
                     handleShow,
                     onSort,
                     sortConfig,
                     onRowReorder,
                   }) => {
  const [draggedId, setDraggedId] = useState(null);
  const [hoverId, setHoverId] = useState(null);
  const can_edit_group = ability.can('whatsappGroups','update')
  const can_delete_group = ability.can('whatsappGroups','destroy')
  const handleDragStart = (e, id) => {
    setDraggedId(id);
    e.dataTransfer.effectAllowed = "move";
    e.currentTarget.style.opacity = "0.4";
  };

  const handleDragOver = (e, id) => {
    e.preventDefault();
    if (id !== draggedId) {
      setHoverId(id);
    }
  };

  const handleDragLeave = () => {
    setHoverId(null);
  };

  const handleDrop = (e, targetId) => {
    e.preventDefault();
    if (draggedId && draggedId !== targetId) {
      onRowReorder(draggedId, targetId);
    }
    setDraggedId(null);
    setHoverId(null);
    e.currentTarget.style.opacity = "1";
  };

  const handleDragEnd = (e) => {
    setDraggedId(null);
    setHoverId(null);
    e.currentTarget.style.opacity = "1";
  };

  const columns = [
    { label: "ID", field: "id" },
    { label: "Title", field: "title" },
    // { label: "URL", field: "url" },
    { label: "Owner", field: "owner" },
    { label: "Reg Date", field: "dateentry" },
    { label: "Status", field: "active" },
  ];

  return (
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="sortable table">
          <TableHead>
            <TableRow className="bg-primary">
              <TableCell className="!text-darkTextColor whitespace-nowrap">
                Order
              </TableCell>
              {columns.map(({ label, field }) => (
                  <TableCell
                      key={field}
                      align="center"
                      className="!text-darkTextColor whitespace-nowrap"
                  >
                    <TableSortLabel
                        active={sortConfig.field === field}
                        direction={sortConfig.field === field ? sortConfig.direction : "asc"}
                        onClick={() => onSort(field)}
                    >
                      {label}
                    </TableSortLabel>
                  </TableCell>
              ))}
              <TableCell
                  align="center"
                  className="!text-darkTextColor whitespace-nowrap"
              >
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item) => (
                <TableRow
                    key={item.id}
                    draggable
                    onDragStart={(e) => handleDragStart(e, item.id)}
                    onDragOver={(e) => handleDragOver(e, item.id)}
                    onDragLeave={handleDragLeave}
                    onDrop={(e) => handleDrop(e, item.id)}
                    onDragEnd={handleDragEnd}
                    style={{
                      cursor: "grab",
                      opacity: draggedId === item.id ? 0.5 : 1,
                      backgroundColor: hoverId === item.id ? "rgba(63, 120, 224, 0.1)" : "inherit",
                      transition: "background-color 0.2s ease, opacity 0.2s ease"
                    }}
                >
                  <TableCell align="center">
                    <div style={{ cursor: "grab" }}>
                      <FaArrowsAlt />
                    </div>
                  </TableCell>
                  <TableCell component="th" scope="row" align="center">
                    {item?.id}
                  </TableCell>
                  <TableCell align="center">{item?.title}</TableCell>
                  {/*<TableCell align="center">*/}
                  {/*  <a*/}
                  {/*      className="inline-block w-full max-w-48 truncate"*/}
                  {/*      href={item?.url}*/}
                  {/*      target="_blank"*/}
                  {/*      rel="noopener noreferrer"*/}
                  {/*  >*/}
                  {/*    {item?.url}*/}
                  {/*  </a>*/}
                  {/*</TableCell>*/}
                  <TableCell align="center">{item?.owner}</TableCell>
                  <TableCell align="center">{item?.dateentry}</TableCell>
                  <TableCell align="center">
                <span
                    className={`badge text-darkTextColor ${
                        item?.active === 1 ? "bg-[#28a745]" : "bg-[#ff6877]"
                    }`}
                >
                  {item?.active === 1 ? "active" : "inactive"}
                </span>
                  </TableCell>
                  <TableCell align="center">
                    <div className="block h-full">
                      <div className="flex gap-x-10 items-center justify-center">
                        {
                          can_edit_group &&
                          <Link
                              to={`/WhatsappGroups/Edit/${item?.id}`}
                              color="inherit"
                              underline="none"
                          >
                            <FaPencilAlt className="text-[#6c757d]" />
                          </Link>
                        }
                        {
                          can_delete_group &&
                          <FaTrashAlt
                              onClick={() => {
                                setSelectedId(item?.id);
                                handleShow();
                              }}
                              className="text-[#d9534f] cursor-pointer"
                          />
                        }



                      </div>
                    </div>
                  </TableCell>
                </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
  );
};

export default DataTable;